import { render, staticRenderFns } from "./Cart_View.vue?vue&type=template&id=5a22b9c2"
import script from "./Cart_View.vue?vue&type=script&lang=js"
export * from "./Cart_View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports